import React from 'react';
import hero_image from '../images/cloud_hero_new.png';
import '../css/bg.css';

const offerings = [
    {
        title: "Cloud Migration",
        icon: "☁️",
        text: "Seamlessly migrate your applications and data to leading cloud platforms like AWS, Microsoft Azure, or Google Cloud for enhanced scalability and efficiency."
    },
    {
        title: "Cloud Infrastructure",
        icon: "🏗️",
        text: "Our experts ensure your cloud environment operates at peak performance through proactive monitoring, auto-scaling, and cost optimization."
    },
    {
        title: "Security Solutions",
        icon: "🔒",
        text: "Protect your data and applications with robust security measures, compliance frameworks, and industry best practices."
    },
    {
        title: "Hybrid Cloud Solutions",
        icon: "🔗",
        text: "Integrate your on-premises infrastructure seamlessly with cloud services for unmatched flexibility and scalability."
    },
    {
        title: "Serverless Architecture",
        icon: "⚡",
        text: "Optimize costs and agility by developing event-driven applications without the need for traditional server management."
    },
    {
        title: "Backup and Recovery",
        icon: "💾",
        text: "Safeguard your critical data with automated redundancy and ensure business continuity with rapid disaster recovery solutions."
    }
];

const awsFeatures = [
    { title: "Expert Guidance", text: "Our AWS certified experts provide valuable insights and hands-on guidance tailored for your cloud journey." },
    { title: "Scalability", text: "Scale computing resources instantly on-demand to meet fluctuating business needs." },
    { title: "Cost Efficiency", text: "Optimize your IT budget with dynamic pay-as-you-go pricing models without upfront commitments." },
    { title: "Reliability", text: "Rely on AWS's globally distributed, secure, and highly available infrastructure backbone." },
    { title: "Future-Ready", text: "Stay ahead of the competition by leveraging AWS's cutting-edge AI, ML, and Analytics tools." }
];

export default function Cloud() {
    return (
        <div className='bg-light' style={{ minHeight: '100vh', paddingBottom: '60px' }}>

            {/* ── Hero Section ─────────────────────────── */}
            <div
                className="position-relative d-flex align-items-center justify-content-center text-center overflow-hidden"
                style={{
                    width: '100%',
                    height: '55vh',
                    backgroundImage: `url(${hero_image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    marginTop: '-1px'
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'linear-gradient(135deg, rgba(15,23,42,0.95) 0%, rgba(15,23,42,0.5) 100%)',
                        zIndex: 1
                    }}
                />
                <div className="container position-relative px-4" style={{ zIndex: 2 }}>
                    <p className="section-label animate-fade-up text-info mb-3">Next-Gen Infrastructure</p>
                    <h1 className="text-white fw-bold animate-fade-up delay-1" style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', lineHeight: 1.1 }}>
                        CLOUD <span className="text-info">COMPUTING</span>
                    </h1>
                    <p className="animate-fade-up delay-2 text-white-50 mt-4 mx-auto" style={{ maxWidth: '750px', fontSize: '1.15rem', lineHeight: 1.6 }}>
                        Cloud computing enables you to securely access, store, and process massive data streams on remote servers. We help you transition away from local compute bottlenecks.
                    </p>
                </div>
            </div>

            {/* ── Offerings Section ─────────────────────── */}
            <div className="container py-6 mt-5">
                <div className="text-center mb-5">
                    <p className="section-label">Enterprise Solutions</p>
                    <h2 className="section-title">Our Cloud Offerings</h2>
                </div>

                <div className="row g-4 justify-content-center">
                    {offerings.map((item, index) => (
                        <div className="col-md-6 col-lg-4 d-flex" key={index}>
                            <div className="ftb-service-card w-100 p-4 text-center">
                                <div className="ftb-card-accent mb-3" />
                                <div style={{ fontSize: '3rem', margin: '15px 0' }}>{item.icon}</div>
                                <h5 className="fw-bold mb-3" style={{ color: 'var(--ftb-text)' }}>
                                    {item.title}
                                </h5>
                                <p style={{ color: 'var(--ftb-text-muted)', fontSize: '0.95rem', lineHeight: 1.6, textAlign: 'left' }}>
                                    {item.text}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── AWS Section ──────────────────────────── */}
            <div className="container-fluid py-5 mt-4" style={{ background: 'var(--ftb-bg-alt)', transition: 'var(--transition)' }}>
                <div className="container pb-4">
                    <div className="text-center mb-5">
                        <p className="section-label text-warning">Premier Partner</p>
                        <h2 className="section-title text-center">Powered by AWS</h2>
                        <p className="mx-auto mt-3" style={{ maxWidth: '800px', fontSize: '1.1rem', color: 'var(--ftb-text-muted)', lineHeight: 1.7 }}>
                            Experience the unmatched power of Amazon Web Services with FTB Innosphere. As a trusted provider, we empower businesses to leverage the full, secure potential of the cloud.
                        </p>
                    </div>

                    <div className="row g-4 justify-content-center">
                        {awsFeatures.map((feature, index) => (
                            <div className="col-lg-2 col-md-4 col-sm-6" key={index}>
                                <div className="ftb-service-card h-100 p-3" style={{ borderTop: '3px solid #f89820' }}>
                                    <h6 className="fw-bold mb-2" style={{ color: 'var(--ftb-text)' }}>{feature.title}</h6>
                                    <p className="m-0" style={{ fontSize: '0.85rem', color: 'var(--ftb-text-muted)', lineHeight: 1.5 }}>{feature.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-5 pt-3 border-top" style={{ borderColor: 'var(--ftb-border)' }}>
                        <p style={{ fontSize: '1.1rem', color: 'var(--ftb-text)' }} className="mb-2">
                            Unlock new possibilities and hyper-growth for your business with our tailored AWS architecture.
                        </p>
                        <p style={{ color: 'var(--ftb-text-muted)' }}>
                            <a href='/contact' className="fw-bold text-info text-decoration-none">Contact us today</a> to start your seamless cloud transition.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    )
}
